import { render, staticRenderFns } from "./Amazake.vue?vue&type=template&id=48bcfde0&scoped=true"
import script from "./Amazake.vue?vue&type=script&lang=js"
export * from "./Amazake.vue?vue&type=script&lang=js"
import style0 from "./Amazake.vue?vue&type=style&index=0&id=48bcfde0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bcfde0",
  null
  
)

export default component.exports